import CloseIcon from '@mui/icons-material/Close';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Button, Stack, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import ContadorPasajeros from './ContadorPasajeros';
import { useEffect } from 'react';
import { useColors } from 'frontend/hooks/useColors';
import './styles.css';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PasajerosFullScreenDialog({
  totalTourists,
  adultsQuantity,
  setAdultsQuantity,
  childrenQuantity,
  setChildrenQuantity,
  babiesQuantity,
  setBabiesQuantity,
  isPackage,
  shouldOpen,
}) {
  const [open, setOpen] = React.useState(false);

  const { background } = useColors();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (shouldOpen) setOpen(true);
  }, [shouldOpen]);

  return (
    <>
      <div
        onClick={handleClickOpen}
        className={`pasajeros-box-container`}
        style={{ width: '100%' }}
      >
        <PersonOutlineIcon style={{ marginRight: 4, fill: '#6b7280' }} />
        <Typography style={{ marginRight: 4 }} color={'#6b7280'}>
          {totalTourists}
        </Typography>
        <Typography color={'#6b7280'}>Pasajero/s</Typography>
      </div>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        disableEnforceFocus
      >
        <AppBar sx={{ position: 'relative', backgroundColor: background }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Cantidad de Pasajeros
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Siguiente
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent
          sx={{
            overflowY: 'scroll',
            maxHeight: '90vh',
          }}
        >
          <div>
            <Stack direction={'row'} spacing={1}>
              <PersonAddAltIcon />
              <Typography>Pasajeros</Typography>
            </Stack>

            <div className={'contador-pasajeros-container'}>
              <ContadorPasajeros
                title={'Adultos'}
                description={!isPackage ? 'desde los 12 años' : ''}
                quantity={adultsQuantity}
                setQuantity={setAdultsQuantity}
                max={isPackage ? 3 : undefined}
              />
              {!isPackage && (
                <>
                  <ContadorPasajeros
                    title={'Niños'}
                    description={'de 2 a 11 años'}
                    quantity={childrenQuantity}
                    setQuantity={setChildrenQuantity}
                  />
                  <ContadorPasajeros
                    title={'Bebes'}
                    description={'menos de 2 años'}
                    quantity={babiesQuantity}
                    setQuantity={setBabiesQuantity}
                  />
                </>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
